import { render, staticRenderFns } from "./Bund.vue?vue&type=template&id=65145fef&scoped=true"
import script from "./Bund.vue?vue&type=script&lang=js"
export * from "./Bund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65145fef",
  null
  
)

export default component.exports